import clsx from 'clsx'
import PropTypes from 'prop-types'
import NumberFormat from 'react-number-format'
import { Controller } from 'react-hook-form'
import { connect } from 'react-redux'

import styles from './style.module.scss'

/**
 * Zahlenfeld.
 *
 * `readOnly` ist etwas anderes als `disabled`: Ein abgegebener Bericht ist nicht
 * „gerade nicht bearbeitbar", er ist fertig. Ein ausgegrautes Eingabefeld sagt
 * das Gegenteil — es sieht aus, als könnte man hineinschreiben, wenn nur etwas
 * anderes erledigt wäre. Deshalb steht der Wert dann als Text in einem Kasten,
 * in derselben Form wie die übrigen Nur-Lese-Ansichten (siehe `UI/ReadOnly`).
 */
function TextFieldNumber(props) {
	// `decimalPrecision` kennt react-number-format nicht — es landete als
	// unbekanntes Attribut am <input> und meldete sich in jeder Konsole.
	// Massgeblich ist `decimalScale`.
	const format = {
		thousandSeparator: '.',
		decimalSeparator: ',',
		decimalScale: props.noDecimal ? 0 : 2,
		fixedDecimalScale: 2
	}

	return (
		<label style={props.mb ? { marginBottom: props.mb } : {}} className={clsx(styles.root, props.className)}>
			{props.label && (
				<span className={styles.inputName}>
					{props.label} {props.required ? <span className={styles.require}>*</span> : ''}
				</span>
			)}
			<Controller
				name={props.name}
				control={props.control}
				render={({ field: { onChange, ref, value, ...field } }) =>
					props.readOnly ? (
						<span className={clsx(styles.readOnly, props.classNameInput)}>
							<NumberFormat {...format} value={props.value ? props.value : value} displayType="text" />
						</span>
					) : (
						<NumberFormat
							{...field}
							{...format}
							value={props.value ? props.value : value}
							onValueChange={({ floatValue }) => onChange(floatValue)}
							disabled={props.disabled || props.isTeacherStudentView}
							className={clsx(styles.input, props.classNameInput)}
							onChange={props.onChange}
							displayType="input"
							type="text"
							getInputRef={ref}
							placeholder={props.placeholder}
						/>
					)
				}
			/>
			{props.error && <span className={styles.error}>{props.error.message}</span>}
		</label>
	)
}

TextFieldNumber.propTypes = {
	label: PropTypes.string,
	error: PropTypes.object,
	name: PropTypes.string.isRequired,
	control: PropTypes.object.isRequired,
	mb: PropTypes.number,
	className: PropTypes.string,
	placeholder: PropTypes.string.isRequired,
	disabled: PropTypes.bool,
	// Fertig statt gesperrt: zeigt den Wert als Text, nicht als graues Feld.
	readOnly: PropTypes.bool,
	classNameInput: PropTypes.string,
	noDecimal: PropTypes.bool,
	isTeacherStudentView: PropTypes.bool.isRequired
}

TextFieldNumber.defaultProps = {
	disabled: false,
	readOnly: false
}

const mapStateToProps = state => ({
	isTeacherStudentView: state.user.isTeacherStudentView
})

export default connect(mapStateToProps)(TextFieldNumber)
